import {
  BookOpen,
  ChevronDown,
  Eye,
  Flame,
  Heart,
  LayoutGrid,
  Leaf,
  Mountain,
  PawPrint,
  Share2,
  SlidersHorizontal,
  Sprout,
  Star,
  Sun,
  User,
  Wind,
  X,
} from 'lucide-react'
import type { LucideProps } from 'lucide-react'

const iconMap = {
  'book-open': BookOpen,
  'chevron-down': ChevronDown,
  eye: Eye,
  flame: Flame,
  heart: Heart,
  leaf: Leaf,
  'layout-grid': LayoutGrid,
  mountain: Mountain,
  'paw-print': PawPrint,
  share: Share2,
  sliders: SlidersHorizontal,
  sprout: Sprout,
  star: Star,
  sun: Sun,
  user: User,
  wind: Wind,
  x: X,
} as const

export type IconName = keyof typeof iconMap

interface IconProps extends Omit<LucideProps, 'ref'> {
  name: IconName
}

export function Icon({ name, size = 20, strokeWidth = 1.5, ...props }: IconProps) {
  const Component = iconMap[name]
  return <Component size={size} strokeWidth={strokeWidth} {...props} />
}
